import { useNavigate } from 'react-router-dom';

interface TotpPromptProps {
  isOpen: boolean;
  onClose: () => void;
  onEnable: () => void;
}

export default function TotpPrompt({ isOpen, onClose, onEnable }: TotpPromptProps) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleEnable = () => {
    onEnable();
    navigate('/security');
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-end sm:items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Card */}
      <div
        className="relative w-full mx-4 mb-6 sm:mb-0 sm:max-w-sm bg-white rounded-3xl p-6 animate-in slide-in-from-bottom duration-300"
        style={{ boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}
      >
        {/* Header icon */}
        <div className="flex flex-col items-center mb-5">
          <div
            className="w-16 h-16 flex items-center justify-center rounded-2xl mb-3"
            style={{
              background: 'linear-gradient(135deg, #F59E0B 0%, #FBBF24 100%)',
              boxShadow: '0 8px 24px rgba(245,158,11,0.25)',
            }}
          >
            <i className="ri-shield-keyhole-line text-white text-2xl" />
          </div>
          <h2 className="text-gray-900 font-bold text-lg">请开启双重验证</h2>
          <p className="text-gray-400 text-xs mt-1 text-center px-2">
            为保护您的账户安全，建议开启 TOTP 双重验证。开启后关闭双重验证和敏感操作将需要额外验证。
          </p>
        </div>

        {/* Feature bullets */}
        <div className="flex flex-col gap-2.5 mb-5">
          {[
            { icon: 'ri-shield-check-line', text: '修改自动交易模式需二次验证', color: '#10B981' },
            { icon: 'ri-link-unlink-m', text: '解绑经纪商账户需二次验证', color: '#6366F1' },
            { icon: 'ri-key-2-line', text: '防止他人盗用账户执行交易', color: '#F59E0B' },
          ].map((item, i) => (
            <div key={i} className="flex items-center gap-2.5">
              <div className="w-6 h-6 flex items-center justify-center rounded-lg flex-shrink-0" style={{ background: `${item.color}15` }}>
                <i className={`${item.icon}`} style={{ color: item.color, fontSize: '13px' }} />
              </div>
              <span className="text-gray-600 text-xs">{item.text}</span>
            </div>
          ))}
        </div>

        {/* Actions */}
        <div className="flex flex-col gap-2.5">
          <button
            onClick={handleEnable}
            className="w-full h-[52px] rounded-2xl text-white font-semibold text-sm flex items-center justify-center gap-2 active:scale-[0.98] transition-transform"
            style={{
              background: 'linear-gradient(135deg, #6366f1 0%, #7c3aed 100%)',
              boxShadow: '0 4px 14px rgba(99,102,241,0.25)',
            }}
          >
            <i className="ri-shield-check-line text-base" />
            去开启
          </button>

          <button
            onClick={onClose}
            className="w-full h-11 rounded-2xl text-gray-400 font-medium text-xs flex items-center justify-center transition-colors hover:bg-gray-50"
          >
            稍后
          </button>
        </div>
      </div>
    </div>
  );
}
